import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import {
  InputLabelComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import { NonNegativeValidatorDirective } from '@navstation-portal/shared/ui/directives';
import {
  offshoreConsumptionsFormEvents,
  offshoreConsumptionsEvents,
  OffshoreConsumptionsFormStore,
  AbstractStoreConnectedSectionComponent,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-boiler-consumptions',
  templateUrl: './boiler-consumptions.component.html',
  styleUrl: './boiler-consumptions.component.css',
  imports: [
    FormsModule,
    InputNumberModule,
    SelectModule,
    NonNegativeValidatorDirective,
    InputLabelComponent,
    NumberInputComponent,
  ],
})
export class BoilerConsumptionsComponent extends AbstractStoreConnectedSectionComponent {
  object = Object;
  tabId = 'consumptions';
  sectionId = 'boilerConsumptions';
  events = injectDispatch(offshoreConsumptionsFormEvents);
  extraEvents = injectDispatch(offshoreConsumptionsEvents);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);
}
